"use strict";

var marko_template = module.exports = require("marko/dist/vdom").t(),
    marko_component = {
    onCreate: function ({outline, fn}) {
        this.state = {};
        this.fhandler = new FormHandler();
        const {title, subtitle} = outline;
        this.fhandler.bind(this, {
            title,
            subtitle
        });
        this.callbackFn = fn;
    },
    onSave: function () {
        if (!this.state.form.title)
            return this.fhandler.error('name');
        typeof this.callbackFn == 'function' && this.callbackFn(this.state.form);
        this.emit('dismiss');
    },
    onEditContent: function () {
        this.emit('edit-content');
        this.emit('dismiss');
    }
},
    components_registry_browser = require("marko/dist/runtime/components/registry-browser"),
    marko_registerComponent = components_registry_browser.r,
    marko_componentType = marko_registerComponent("/MP.WEB$2.0/src/views/smoothy~1.0/pages/Courses/create/Content/components/EditOutline.marko", function() {
      return module.exports;
    }),
    marko_renderer = require("marko/dist/runtime/components/renderer"),
    marko_defineComponent = require("marko/dist/runtime/components/defineComponent"),
    module_FormHandler = require("markojs-form"),
    FormHandler = module_FormHandler.default || module_FormHandler,
    Locale_template = require("../../../../../../components/Locale/index.marko"),
    marko_loadTag = require("marko/dist/runtime/helpers/load-tag"),
    Locale_tag = marko_loadTag(Locale_template),
    marko_classValue = require("marko/dist/runtime/helpers/class-value"),
    marko_styleValue = require("marko/dist/runtime/helpers/style-value"),
    Row_template = require("../../../../../../components/Row/index.marko"),
    Row_tag = marko_loadTag(Row_template),
    WSAdapt_template = require("../../../../../../components/WSAdapt/index.marko"),
    WSAdapt_tag = marko_loadTag(WSAdapt_template),
    marko_attrs0 = {
        "class": "position-absolute zindex-2 w-100 h-100 top-0 left-0 d-flex align-items-center center"
      },
    marko_attrs1 = {
        "class": "position-fixed top-0 w-100 h-100 theme-bg-transparent animated fadeIn faster"
      },
    marko_attrs2 = {
        "class": "text-muted"
      },
    marko_createElement = require("marko/dist/runtime/vdom/helpers/v-element"),
    marko_const = require("marko/dist/runtime/vdom/helpers/const"),
    marko_const_nextId = marko_const("52045e"),
    marko_node0 = marko_createElement("br", null, "8", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_attrs3 = {
        "class": "form-group"
      },
    marko_node1 = marko_createElement("br", null, "12", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_attrs4 = {
        "class": "form-group"
      },
    marko_node2 = marko_createElement("br", null, "19", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_node3 = marko_createElement("br", null, "21", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_attrs5 = {
        "class": "col-7"
      },
    marko_attrs6 = {
        "class": "btn btn-secondary m-25"
      },
    marko_attrs7 = {
        "class": "btn btn-secondary m-25"
      },
    marko_attrs8 = {
        "class": "col text-right"
      },
    marko_attrs9 = {
        "class": "btn btn-primary m-25"
      };

function render(input, out, __component, component, state) {
  var data = input;

  out.be("div", marko_attrs0, "0", component);

  Row_tag({
      class: "m-0 w-100 d-flex justify-content-center",
      renderBody: function(out) {
        out.e("div", marko_attrs1, "2", component, 0, 0, {
            onclick: __component.d("click", () => component.emit('dismiss'), false)
          });

        WSAdapt_tag({
            ns: "col-9",
            qs: "col-9",
            hs: "col-10",
            class: "animated zoomIn faster",
            style: "padding-bottom:150px",
            renderBody: function(out) {
              out.be("h5", null, "4", component);

              Locale_tag({
                  text: "Edit Outline"
                }, out, __component, "5");

              out.ee();

              out.be("p", marko_attrs2, "6", component);

              Locale_tag({
                  renderBody: function(out) {
                    out.t("Note that any changes made here have no repercution on the original content in the library.");
                  }
                }, out, __component, "7");

              out.ee();

              out.n(marko_node0, component);

              out.be("div", marko_attrs3, "9", component);

              out.be("label", null, "10", component);

              Locale_tag({
                  text: "Title",
                  class: "text-muted"
                }, out, __component, "11");

              out.ee();

              out.n(marko_node1, component);

              out.e("input", {
                  type: "text",
                  value: state.form.title,
                  name: "title",
                  "class": marko_classValue("form-control form-control-xl px-2" + (state.formError.title != undefined ? state.formError.title ? " is-invalid" : " is-valid" : "")),
                  validate: "required",
                  placeholder: Locale("Title*")
                }, "13", component, 0, 0, {
                  onchange: __component.d("change", "__onChange", false)
                });

              out.be("p", {
                  "class": marko_classValue("small mt-50 mb-2" + (!state.formError.title ? " d-none" : ""))
                }, "14", component, null, 1);

              Locale_tag({
                  text: "This field is required"
                }, out, __component, "15");

              out.ee();

              out.ee();

              out.be("div", marko_attrs4, "16", component);

              out.be("label", null, "17", component);

              Locale_tag({
                  text: "Subtitle / Description",
                  class: "text-muted"
                }, out, __component, "18");

              out.ee();

              out.n(marko_node2, component);

              out.e("textarea", {
                  value: state.form.subtitle,
                  name: "subtitle",
                  "class": marko_classValue("form-control form-control-xl px-2 " + (state.formError.subtitle != null ? state.formError.subtitle ? " is-invalid" : " is-valid" : "")),
                  placeholder: Locale("Subtitle"),
                  style: marko_styleValue({
                      height: "100px",
                      resize: "none"
                    })
                }, "20", component, 0, 0, {
                  onchange: __component.d("change", "__onChange", false)
                });

              out.ee();

              out.n(marko_node3, component);

              Row_tag({
                  renderBody: function(out) {
                    out.be("div", marko_attrs5, "23", component);

                    out.be("button", marko_attrs6, "24", component, null, 0, {
                        onclick: __component.d("click", () => component.emit('dismiss'), false)
                      });

                    Locale_tag({
                        text: "Cancel"
                      }, out, __component, "25");

                    out.ee();

                    out.be("button", marko_attrs7, "26", component, null, 0, {
                        onclick: __component.d("click", "onEditContent", false)
                      });

                    Locale_tag({
                        text: "Edit Content"
                      }, out, __component, "27");

                    out.ee();

                    out.ee();

                    out.be("div", marko_attrs8, "28", component);

                    out.be("button", marko_attrs9, "29", component, null, 0, {
                        onclick: __component.d("click", "onSave", false)
                      });

                    Locale_tag({
                        text: "Save"
                      }, out, __component, "30");

                    out.ee();

                    out.ee();
                  }
                }, out, __component, "22");
            }
          }, out, __component, "3");
      }
    }, out, __component, "1");

  out.ee();
}

marko_template._ = marko_renderer(render, {
    e_: marko_componentType
  }, marko_component);

marko_template.Component = marko_defineComponent(marko_component, marko_template._);
